import api from "./api";
import { getsListServicio } from "./servicioService";

// Diagnosticos. Se registran sobre la persona: la API crea la atencion con su
// detalle al guardar uno nuevo.
const diagnosticoService = {
    getsDiagnostico: async (filtros = {}) => {
        const response = await api.get("/Diagnostico/GetsDiagnostico", {
            params: {
                persona: filtros.persona || "",
                fechaInicio: filtros.fechaInicio || null,
                fechaFin: filtros.fechaFin || null,
            },
        });
        return response.data.data || [];
    },

    // Referencia a la atencion del diagnostico, leida desde su detalle.
    getsAtencionPorDiagnostico: async (idAtencion, numero) => {
        const response = await api.get("/Diagnostico/GetsAtencionPorDiagnostico", {
            params: { idAtencion, numero },
        });
        return response.data.data;
    },

    // Devuelve { idAtencion, numero }: la atencion en la que quedo y su numero.
    addUpdateDiagnostico: async (diagnostico) => {
        const response = await api.post("/Diagnostico/AddUpdateDiagnostico", diagnostico);
        return response.data.data;
    },

    deleteDiagnostico: async (idAtencion, numero) => {
        const response = await api.post("/Diagnostico/DeleteDiagnostico?idAtencion=" + idAtencion + "&numero=" + numero);
        return response.data.data;
    },

    getsPrograma: async () => {
        const response = await api.get("/Diagnostico/GetsPrograma");
        return response.data.data || [];
    },

    // Servicios que ofrece el instituto (tabla servicio).
    getsServicios: async () => {
        return getsListServicio().catch(() => []);
    },
};

export default diagnosticoService;